import type { FC } from 'react';
import { Home, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

export const NotFoundPage: FC = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center p-6">
      <div className="w-16 h-16 rounded-2xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 mb-6 shadow-xl">
        <Search className="w-8 h-8" />
      </div>
      <h1 className="text-4xl font-extrabold text-white mb-2">404</h1>
      <p className="text-slate-400 text-sm max-w-sm mb-6">
        The route you are looking for does not exist in the keerav camp application shell (Developed by Axiino).
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-brand-600 hover:bg-brand-500 text-white font-medium text-sm transition-colors shadow-lg shadow-brand-600/20"
      >
        <Home className="w-4 h-4" />
        Return to Overview
      </Link>
    </div>
  );
};
